<template>
    <div class="tinymce-editor">
        <editor v-model="myValue"
                :init="init"
                :disabled="disabled"
                @onClick="onClick">
        </editor>
    </div>
</template>
<script>
    import tinymce from 'tinymce/tinymce'
    import Editor from '@tinymce/tinymce-vue'
    import 'tinymce/themes/silver'
    import 'tinymce/icons/default'
    import 'tinymce/plugins/image'// 插入上传图片插件
    import 'tinymce/plugins/media'// 插入视频插件
    import 'tinymce/plugins/table'// 插入表格插件
    import 'tinymce/plugins/lists'// 列表插件
    import 'tinymce/plugins/advlist'// 列表插件
    import 'tinymce/plugins/colorpicker'
    import 'tinymce/plugins/contextmenu'
    import 'tinymce/plugins/searchreplace'
    import 'tinymce/plugins/visualblocks'
    import 'tinymce/plugins/insertdatetime'
    import 'tinymce/plugins/autoresize'
    import 'tinymce/plugins/imagetools'// 图片编辑
    import 'tinymce/plugins/fullscreen'
    import 'tinymce/plugins/paste'
    import {
        uploadFile
    } from "../../utils/interface";
    export default {
        components: {
            Editor,
            uploadFile
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            baseUrl: {
                type: String,
                default: 'static'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            plugins: {
                type: [String, Array],
                default: 'imagetools image lists advlist table autoresize,media'
            },
            toolbar: {
                type: [String, Array],
                default: 'undo redo | fontselect | fontsizeselect | bold italic backcolor forecolor |imagetools image media| table | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lineheight '
            }
        },
        data () {
            return {
                qiniuToken:null,
                resVideo:null,
                uploaded:false,
                init: {
                    language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
                    language: 'zh_CN',
                    skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
                    content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
                    min_height: 400,
                    plugins: this.plugins,
                    toolbar: this.toolbar,
                    branding: false,
                    menubar: false,
                    statusbar: false,
                    object_resizing: true,
                    placeholder: '请在此处输入内容',
                    fontsize_formats: '一号=26pt 小一=24pt 二号=22pt 小二=18pt 三号=16pt 小三=15pt 四号=14pt 小四=12pt',
                    lineheight_formats: '1 1.5 2 2.5 3',
                    images_upload_handler: (blobInfo, success, failure) => {
                        var formData;
                        formData = new FormData();
                        formData.append('file',blobInfo.blob(), blobInfo.filename());

                        // 上传接口
                        uploadFile(formData).then((res)=>{
                            success(res.url);
                        })
                        // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
                        // success(img)
                    },
                    file_picker_types: 'media',
                    file_picker_callback: (callback, value, meta)=> {
                        this.open(callback, value, meta)
                    },
                    toolbar_mode: 'wrap'
                },
                myValue: this.value,
                pageTitle: ''
            }
        },
        mounted () {
            tinymce.init({})
        },
        methods: {
            // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
            // 需要什么事件可以自己增加
            onClick (e) {
                this.$emit('onClick', e, tinymce)
            },
            // 可以添加一些自己的自定义事件，如清空内容
            clear () {
                this.myValue = ''
            },
            // 上传视频拿到url
            open(callback, value, meta){
                if (meta.filetype == 'media') {
                    let input = document.createElement('input');//创建一个隐藏的input
                    input.setAttribute('type', 'file');
                    let that = this;
                    input.onchange = function(){
                        let file = this.files[0];//选取第一个文件
                        that.uploadVideo(file,'media'); // 上传视频拿到url
                        setTimeout(()=>{
                            if(that.uploaded){
                                console.log(that.resVideo,'true')
                                callback(that.resVideo) //将url显示在弹框输入框中
                            }else{
                                setTimeout(()=>{
                                    //设置几秒后再去取数据
                                    console.log(that.resVideo,'false')
                                    callback(this.resVideo)
                                },5000)
                            }
                        },5000)
                    }
            
                    //触发点击
                    input.click();
                }
            },
            // 插入视频的方法
            uploadVideo(file,type){
                console.log(file)
                uploadFile(file).then(response =>{
                    console.log(response)
                    if (response.code == 200) {
                        if(type == 'media') {
                            this.resVideo = response.url
                            this.options.uploaded = true
                        }
                        console.log('dsdsdoooooooo', this.options.uploaded)
                    }
                })
            },
        },
        watch: {
            value (newValue) {
                this.myValue = newValue
            },
            myValue (newValue) {
                this.$emit('input', newValue)
            }
        }
    }
</script>
<style scoped lang="less">
    .tinymce-editor{
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/tinymce/index.vue